import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { DisplayComponent } from '@app/shared/components/display/display.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { PlayGamesService } from '@app/core/play-games/play-games.service';

@Component({
  selector: 'slotcom-daily-bonus-modal',
  templateUrl: './daily-bonus.component.html',
  styleUrls: ['./daily-bonus.component.scss'],
  standalone: true,
  imports: [DisplayComponent, ButtonComponent, SharedModule],
})
export class DailyBonusModalComponent {
  dailyBonusModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  private playGamesService = inject(PlayGamesService);

  closeModal() {
    this.eventManager.closeModal(new Modal(this.dailyBonusModalData.id, ModalType.Persisted, this.dailyBonusModalData));
    this.playGamesService.sendGameStat('stats', { daysPlayed: 1 });
  }
}
